import { type ShipmentWithRelations } from '@/models/shipment';
import { useCountries } from '@/services/i18n';

export const useDisplayedShipmentCountry = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  const countries = useCountries();

  const areCountriesDifferent =
    shipment.originAddress?.country !== shipment.destinationAddress?.country;

  const originCountry =
    !!shipment.originAddress?.country && areCountriesDifferent
      ? countries.find((country) => country.code === shipment.originAddress?.country)
      : undefined;

  const destinationCountry =
    !!shipment.destinationAddress?.country && areCountriesDifferent
      ? countries.find((country) => country.code === shipment.destinationAddress?.country)
      : undefined;

  return {
    originCountry,
    destinationCountry,
  };
};
